export class SearchDirectoryEntitiesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "data",
            "baseName": "data",
            "type": "Array<DirectoryEntityRecord>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        },
        {
            "name": "typeCounts",
            "baseName": "typeCounts",
            "type": "Array<DirectoryEntityTypeCount>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SearchDirectoryEntitiesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
